import { WithUsers } from '../../users';
import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { EnrichedRepriceRequest, ProjectRepriceRequest } from '../types';

export interface ProjectsByStatusLoadParams {
  status: string;
  startDate?: string;
  endDate?: string;
  team?: string;
  paginationToken?: string;
  ref?: 'STATUS' | 'TEAM' | 'OWN';
}

export const repriceLoaders = getLoaders({
  listActiveReprices: {
    load: async (): Promise<Record<string, EnrichedRepriceRequest>> => {
      return executeApiCall({
        path: `/projects/reprice`,

        method: 'get',
      });
    },
  },

  getProjectsActiveReprice: {
    load: async ({ projectId }: { projectId: string }): Promise<ProjectRepriceRequest> => {
      return executeApiCall({
        path: `/projects/reprice/${projectId}`,

        method: 'get',
      });
    },
  },

  allProjectsReprices: {
    load: async ({
      projectId,
    }: {
      projectId: string;
    }): Promise<
      WithUsers<ProjectRepriceRequest, 'repricedBy' | 'requestedBy' | 'finishedBy'>[]
    > => {
      return executeApiCall({
        path: `/projects/reprice/all/${projectId}`,

        method: 'get',
      });
    },
  },
});
